import { useState } from "react";
import { useDispatch } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";
import LoginService from "../../../services/login";
import { motion } from "framer-motion";
import { useNavigate } from "react-router";
import { setToken } from "../../../redux/slices/loginSlice";

function isValidIranianNationalCode(raw) {
  const code = String(raw).replace(/\D/g, "");
  if (!/^\d{10}$/.test(code)) return false;
  if (/^(\d)\1{9}$/.test(code)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(code[i], 10) * (10 - i);
  }
  const remainder = sum % 11;
  const check = parseInt(code[9], 10);
  return (remainder < 2 && check === remainder) || (remainder >= 2 && check === 11 - remainder);
}

export default function InfoStep({ phone, onBack ,token}) {
  const dispatch = useDispatch();

  const [loadingBtn, setLoadingBtn] = useState(false);

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationalCode, setNationalCode] = useState("");
    const navigate=useNavigate()
 
  const [fieldErrors, setFieldErrors] = useState({
    name: "",
    lastName: "",
    nationalCode: "",
    general: "",
  });


  const [shake, setShake] = useState({
    name: false,
    lastName: false,
    nationalCode: false,
  });

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };


  const triggerShake = (field) => {
    setShake((s) => ({ ...s, [field]: true }));
    setTimeout(() => {
      setShake((s) => ({ ...s, [field]: false }));
    }, 350); 
  };


  const clearFieldError = (field) => {
    setFieldErrors((prev) => ({ ...prev, [field]: "" }));
  };


  const runLocalValidation = () => {
    const errs = { name: "", lastName: "", nationalCode: "" };
    if (!name.trim()) errs.name = "نام الزامی است";
    else if (/\d/.test(name)) errs.name = "نام نمی‌تواند شامل عدد باشد";

    if (!lastName.trim()) errs.lastName = "نام خانوادگی الزامی است";
    else if (/\d/.test(lastName)) errs.lastName = "نام خانوادگی نمی‌تواند شامل عدد باشد";

    const cleanedNational = nationalCode.replace(/\D/g, "");
    if (!cleanedNational) errs.nationalCode = "کد ملی الزامی است";
    else if (!/^\d{10}$/.test(cleanedNational)) errs.nationalCode = "کد ملی باید 10 رقم باشد";
    else if (!isValidIranianNationalCode(cleanedNational)) errs.nationalCode = "کد ملی نامعتبر است";

    setFieldErrors((prev) => ({ ...prev, ...errs }));

    (Object.keys(errs)).forEach((k) => {
      if (errs[k]) triggerShake(k);
    });

    return !(errs.name || errs.lastName || errs.nationalCode);
  };



  function prepareForApi(input) {

    let digits = input.replace(/\D/g, "");
  

    if (digits.startsWith("0")) {
      digits = digits.slice(1);
    }
  
    return digits; 
  }
  
  const handleSubmit = async () => {

    setFieldErrors((p) => ({ ...p, general: "" }));


    if (!runLocalValidation()) return;


    setLoadingBtn(true);
    try {
      const body = {
        firstname: name.trim(),
        lastname: lastName.trim(),
        national_code: nationalCode.replace(/\D/g, ""),

      };
    

      const res = await LoginService.submitInfo(body) 

      if (res?.status === 200 || res?.status === 201) {
     
        dispatch(setToken(token))
        navigate("/cargo")
        return;
      }


      if (res?.data) {

        const data = res.data;

        if (data.errors && typeof data.errors === "object") {

          const newErrs = { name: "", lastName: "", nationalCode: "", general: "" };
          for (const key in data.errors) {
            if (key in newErrs) newErrs[key] = data.errors[key];
            else newErrs.general = data.errors[key];
          }
          setFieldErrors((p) => ({ ...p, ...newErrs }));
          Object.keys(newErrs).forEach((k) => {
            if (newErrs[k]) triggerShake(k);
          });
        } else if (data.message) {
          setFieldErrors((p) => ({ ...p, general: data.message }));
         
          triggerShake("nationalCode");
        } else {
          setFieldErrors((p) => ({ ...p, general: "مشکلی پیش آمد، دوباره تلاش کنید" }));
          triggerShake("nationalCode");
        }
      }
       else {
        setFieldErrors((p) => ({ ...p, general: "پاسخ نامعتبر از سرور" }));
        triggerShake("nationalCode");
      }
    } catch (err) {

      const data = err?.data?.resdata;
      if (data) {
        if (data.errors && typeof data.errors === "object") {
          const newErrs = { name: "", lastName: "", nationalCode: "", general: "" };
          for (const key in data.errors) {
            if (key in newErrs) newErrs[key] = data.errors[key];
            else newErrs.general = data.errors[key];
          }
          setFieldErrors((p) => ({ ...p, ...newErrs }));
          Object.keys(newErrs).forEach((k) => {
            if (newErrs[k]) triggerShake(k);
          });
        } else if (data.message) {
          setFieldErrors((p) => ({ ...p, general: data.message }));
          triggerShake("nationalCode");
        } else {
          setFieldErrors((p) => ({ ...p, general: "خطای شبکه، لطفا دوباره تلاش کنید" }));
          triggerShake("nationalCode");
        }
      } else {
        setFieldErrors((p) => ({ ...p, general: "ارتباط با سرور برقرار نشد" }));
        triggerShake("nationalCode");
      }
    } finally {
      setLoadingBtn(false);
    }
  };


  const fieldsetClass = (hasError, doShake) =>
    `h-max relative w-full rounded-[15px] mt-1 p-2.5 box-border ${
      hasError ? `border-2 border-red-500 ${doShake ? "animate-shake" : ""}` : "border-2 border-gray-400"
    }`;

  const legendClass = (hasError) =>
    `px-2 text-sm bg-white rtl:ml-3 ltr:ml-3 lg:text-[17px] text-[13px] ${hasError ? "text-red-500" : "text-[#112C85]"}`;

  return (
    <>
      <div className="w-full min-h-screen flex flex-col items-center justify-center px-5 lg:px-10 overflow-x-hidden">
        <motion.div variants={fadeUp} initial="hidden" animate="show" className="flex flex-col justify-center items-start text-start md:w-[400px] w-full gap-2">
          <div className="flex flex-row justify-center w-full h-max">
            <img className="w-[80px] object-contain" src="./icon-512.png" alt="logo" />
          </div>

          <div className="flex flex-col justify-center">
            <div className="flex flex-row gap-1 items-center justify-start text-[20px] text-gray-600">
              <p className="inline">ورود |</p>
              <p className="inline">ثبت نام</p>
            </div>
            <p className="lg:text-[17px] text-[15px] text-gray-400 mt-4">
              لطفا اطلاعات زیر را جهت ارائه خدمات بهتر وارد کنید
            </p>
          </div>


          <fieldset className={fieldsetClass(!!fieldErrors.name, shake.name)}>
            <legend className={legendClass(!!fieldErrors.name)}>نام</legend>
            <input
              dir="ltr"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                clearFieldError("name");
              }}
              type="text"
              placeholder="نام"
              className="w-full h-[22px] text-right lg:text-[17px] text-[13px] border-none outline-none px-4 bg-transparent text-base"
              aria-invalid={!!fieldErrors.name}
              aria-describedby="name-error"
            />
          </fieldset>
          {fieldErrors.name && (
            <p id="name-error" className="text-red-500 text-sm mt-1 px-1" role="alert">
              {fieldErrors.name}
            </p>
          )}


          <fieldset className={fieldsetClass(!!fieldErrors.lastName, shake.lastName)}>
            <legend className={legendClass(!!fieldErrors.lastName)}>نام خانوادگی</legend>
            <input
              dir="ltr"
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                clearFieldError("lastName");
              }}
              type="text"
              placeholder="نام خانوادگی"
              className="w-full h-[22px] text-right lg:text-[17px] text-[13px] border-none outline-none px-4 bg-transparent text-base"
              aria-invalid={!!fieldErrors.lastName}
              aria-describedby="lastname-error"
            />
          </fieldset>
          {fieldErrors.lastName && (
            <p id="lastname-error" className="text-red-500 text-sm mt-1 px-1" role="alert">
              {fieldErrors.lastName}
            </p>
          )}

          {/* کد ملی */}
          <fieldset className={fieldsetClass(!!fieldErrors.nationalCode, shake.nationalCode)}>
            <legend className={legendClass(!!fieldErrors.nationalCode)}>کد ملی</legend>
            <input
              dir="ltr"
              value={nationalCode}
              onChange={(e) => {
                // فقط ارقام و حداکثر 10 رقم
                const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                setNationalCode(digits);
                clearFieldError("nationalCode");
              }}
              type="tel"
              inputMode="numeric"
              placeholder="کد ملی"
              className="w-full h-[22px] text-right lg:text-[17px] text-[13px] border-none outline-none px-4 bg-transparent text-base"
              aria-invalid={!!fieldErrors.nationalCode}
              aria-describedby="nationalcode-error"
            />
          </fieldset>
          {fieldErrors.nationalCode && (
            <p id="nationalcode-error" className="text-red-500 text-sm mt-1 px-1" role="alert">
              {fieldErrors.nationalCode}
            </p>
          )}

          {/* پیام عمومی ارور */}
          {fieldErrors.general && (
            <p className="text-red-500 text-sm mt-2 px-1" role="alert">
              {fieldErrors.general}
            </p>
          )}

          <div className="flex flex-row gap-1 w-full justify-center items-center mt-5">
            <button
              onClick={handleSubmit}
              disabled={loadingBtn}
              className={`md:w-[340px] w-[300px] h-[60px] bg-special ${loadingBtn ? "bg-opacity-70" : "bg-opacity-100"} flex flex-row justify-center items-center text-white rounded-xl`}
            >
              <p className="text-[20px]">{loadingBtn ? "منتظر بمانید ..." : "ورود"}</p>
            </button>

            <button onClick={onBack} className={`w-[60px] h-[60px] bg-special ${loadingBtn ? "bg-opacity-70" : "bg-opacity-100"} flex flex-row justify-center items-center text-white rounded-xl`}>
              <IoIosArrowBack size={20} />
            </button>
          </div>
        </motion.div>
      </div>
    </>
  );
}
